import type { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/sso/callback',
    name: 'sso-callback',
    component: () => import('@/views/auth/SsoCallback.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/Register.vue')
  },
  {
    path: '/trial-confirm',
    name: 'trial-confirm',
    component: () => import('@/views/commercial/TrialConfirm.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPassword.vue')
  },
  {
    path: '/force-change-password',
    name: 'force-change-password',
    component: () => import('@/views/auth/ForceChangePassword.vue')
  }
]

export default authRoutes
